module.exports = __webpack_public_path__ + "static/media/kitty-pryde-icon.7e3a22f6.png";